module.exports = __webpack_public_path__ + "static/media/crystalline.9673119d.jpg";